import type { FC, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export interface CustomerTimelineIconNodeProps {
  /** Decorative icon, about 16px. */
  icon: ReactNode;
  /** Dashed and lighter, for something that hasn't happened yet. */
  isUpcoming?: boolean;
}

/** A 28px circle with an icon, for an interaction such as a call or texts. */
export const CustomerTimelineIconNode: FC<CustomerTimelineIconNodeProps> = (
  props,
) => {
  const { icon, isUpcoming } = props;
  return (
    <span
      className={twMerge(
        "flex size-7 shrink-0 items-center justify-center rounded-full bg-gray-50 text-muted-foreground",
        isUpcoming &&
          "border border-dashed border-border-strong bg-card text-muted-foreground/60",
      )}
    >
      {icon}
    </span>
  );
};

export interface CustomerTimelineDotNodeProps {
  /** Pulses the dot in violet, for a state that is still going on. */
  isLive?: boolean;
}

/** A 6px dot, for activity such as a call being requested or canceled. */
export const CustomerTimelineDotNode: FC<CustomerTimelineDotNodeProps> = (
  props,
) => {
  const { isLive } = props;
  return (
    <span
      className={twMerge(
        "relative size-1.5 rounded-full bg-gray-400",
        isLive && "bg-violet-400",
      )}
    >
      {isLive && (
        <span className="absolute inset-0 rounded-full bg-violet-400 motion-safe:animate-[ping_2.5s_cubic-bezier(0,0,0.2,1)_infinite]" />
      )}
    </span>
  );
};
